/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShockEventListUpdate } from './ShockEventListUpdate';
import {
    ShockEventListUpdateFromJSON,
    ShockEventListUpdateFromJSONTyped,
    ShockEventListUpdateToJSON,
    ShockEventListUpdateToJSONTyped,
} from './ShockEventListUpdate';
import type { FleetStatisticsListUpdate } from './FleetStatisticsListUpdate';
import {
    FleetStatisticsListUpdateFromJSON,
    FleetStatisticsListUpdateFromJSONTyped,
    FleetStatisticsListUpdateToJSON,
    FleetStatisticsListUpdateToJSONTyped,
} from './FleetStatisticsListUpdate';
import type { UserProductivityListUpdate } from './UserProductivityListUpdate';
import {
    UserProductivityListUpdateFromJSON,
    UserProductivityListUpdateFromJSONTyped,
    UserProductivityListUpdateToJSON,
    UserProductivityListUpdateToJSONTyped,
} from './UserProductivityListUpdate';
import type { PreOpsAnswerListUpdate } from './PreOpsAnswerListUpdate';
import {
    PreOpsAnswerListUpdateFromJSON,
    PreOpsAnswerListUpdateFromJSONTyped,
    PreOpsAnswerListUpdateToJSON,
    PreOpsAnswerListUpdateToJSONTyped,
} from './PreOpsAnswerListUpdate';
import type { UserListUpdate } from './UserListUpdate';
import {
    UserListUpdateFromJSON,
    UserListUpdateFromJSONTyped,
    UserListUpdateToJSON,
    UserListUpdateToJSONTyped,
} from './UserListUpdate';
import type { VehicleProductivityListUpdate } from './VehicleProductivityListUpdate';
import {
    VehicleProductivityListUpdateFromJSON,
    VehicleProductivityListUpdateFromJSONTyped,
    VehicleProductivityListUpdateToJSON,
    VehicleProductivityListUpdateToJSONTyped,
} from './VehicleProductivityListUpdate';
import type { UserGroupDetailsUpdate } from './UserGroupDetailsUpdate';
import {
    UserGroupDetailsUpdateFromJSON,
    UserGroupDetailsUpdateFromJSONTyped,
    UserGroupDetailsUpdateToJSON,
    UserGroupDetailsUpdateToJSONTyped,
} from './UserGroupDetailsUpdate';
import type { VehicleListUpdate } from './VehicleListUpdate';
import {
    VehicleListUpdateFromJSON,
    VehicleListUpdateFromJSONTyped,
    VehicleListUpdateToJSON,
    VehicleListUpdateToJSONTyped,
} from './VehicleListUpdate';
import type { MaintenanceListUpdate } from './MaintenanceListUpdate';
import {
    MaintenanceListUpdateFromJSON,
    MaintenanceListUpdateFromJSONTyped,
    MaintenanceListUpdateToJSON,
    MaintenanceListUpdateToJSONTyped,
} from './MaintenanceListUpdate';
import type { FleetAuthenticatePeriodListUpdate } from './FleetAuthenticatePeriodListUpdate';
import {
    FleetAuthenticatePeriodListUpdateFromJSON,
    FleetAuthenticatePeriodListUpdateFromJSONTyped,
    FleetAuthenticatePeriodListUpdateToJSON,
    FleetAuthenticatePeriodListUpdateToJSONTyped,
} from './FleetAuthenticatePeriodListUpdate';
import type { VehicleMovementPeriodListUpdate } from './VehicleMovementPeriodListUpdate';
import {
    VehicleMovementPeriodListUpdateFromJSON,
    VehicleMovementPeriodListUpdateFromJSONTyped,
    VehicleMovementPeriodListUpdateToJSON,
    VehicleMovementPeriodListUpdateToJSONTyped,
} from './VehicleMovementPeriodListUpdate';

/**
 * 
 * @export
 * @interface ColumnVisibilityUpdate
 */
export interface ColumnVisibilityUpdate {
    /**
     * 
     * @type {UserListUpdate}
     * @memberof ColumnVisibilityUpdate
     */
    userList?: UserListUpdate | null;
    /**
     * 
     * @type {UserGroupDetailsUpdate}
     * @memberof ColumnVisibilityUpdate
     */
    userGroupDetails?: UserGroupDetailsUpdate | null;
    /**
     * 
     * @type {UserProductivityListUpdate}
     * @memberof ColumnVisibilityUpdate
     */
    userProductivityList?: UserProductivityListUpdate | null;
    /**
     * 
     * @type {VehicleListUpdate}
     * @memberof ColumnVisibilityUpdate
     */
    vehicleList?: VehicleListUpdate | null;
    /**
     * 
     * @type {VehicleProductivityListUpdate}
     * @memberof ColumnVisibilityUpdate
     */
    vehicleProductivityList?: VehicleProductivityListUpdate | null;
    /**
     * 
     * @type {VehicleMovementPeriodListUpdate}
     * @memberof ColumnVisibilityUpdate
     */
    vehicleMovementPeriodList?: VehicleMovementPeriodListUpdate | null;
    /**
     * 
     * @type {MaintenanceListUpdate}
     * @memberof ColumnVisibilityUpdate
     */
    maintenanceList?: MaintenanceListUpdate | null;
    /**
     * 
     * @type {FleetAuthenticatePeriodListUpdate}
     * @memberof ColumnVisibilityUpdate
     */
    fleetAuthenticatePeriodList?: FleetAuthenticatePeriodListUpdate | null;
    /**
     * 
     * @type {ShockEventListUpdate}
     * @memberof ColumnVisibilityUpdate
     */
    shockEventList?: ShockEventListUpdate | null;
    /**
     * 
     * @type {PreOpsAnswerListUpdate}
     * @memberof ColumnVisibilityUpdate
     */
    preOpsAnswerList?: PreOpsAnswerListUpdate | null;
    /**
     * 
     * @type {FleetStatisticsListUpdate}
     * @memberof ColumnVisibilityUpdate
     */
    fleetStatisticsList?: FleetStatisticsListUpdate | null;
}

/**
 * Check if a given object implements the ColumnVisibilityUpdate interface.
 */
export function instanceOfColumnVisibilityUpdate(value: object): value is ColumnVisibilityUpdate {
    return true;
}

export function ColumnVisibilityUpdateFromJSON(json: any): ColumnVisibilityUpdate {
    return ColumnVisibilityUpdateFromJSONTyped(json, false);
}

export function ColumnVisibilityUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ColumnVisibilityUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'userList': json['userList'] == null ? undefined : UserListUpdateFromJSON(json['userList']),
        'userGroupDetails': json['userGroupDetails'] == null ? undefined : UserGroupDetailsUpdateFromJSON(json['userGroupDetails']),
        'userProductivityList': json['userProductivityList'] == null ? undefined : UserProductivityListUpdateFromJSON(json['userProductivityList']),
        'vehicleList': json['vehicleList'] == null ? undefined : VehicleListUpdateFromJSON(json['vehicleList']),
        'vehicleProductivityList': json['vehicleProductivityList'] == null ? undefined : VehicleProductivityListUpdateFromJSON(json['vehicleProductivityList']),
        'vehicleMovementPeriodList': json['vehicleMovementPeriodList'] == null ? undefined : VehicleMovementPeriodListUpdateFromJSON(json['vehicleMovementPeriodList']),
        'maintenanceList': json['maintenanceList'] == null ? undefined : MaintenanceListUpdateFromJSON(json['maintenanceList']),
        'fleetAuthenticatePeriodList': json['fleetAuthenticatePeriodList'] == null ? undefined : FleetAuthenticatePeriodListUpdateFromJSON(json['fleetAuthenticatePeriodList']),
        'shockEventList': json['shockEventList'] == null ? undefined : ShockEventListUpdateFromJSON(json['shockEventList']),
        'preOpsAnswerList': json['preOpsAnswerList'] == null ? undefined : PreOpsAnswerListUpdateFromJSON(json['preOpsAnswerList']),
        'fleetStatisticsList': json['fleetStatisticsList'] == null ? undefined : FleetStatisticsListUpdateFromJSON(json['fleetStatisticsList']),
    };
}

export function ColumnVisibilityUpdateToJSON(json: any): ColumnVisibilityUpdate {
    return ColumnVisibilityUpdateToJSONTyped(json, false);
}

export function ColumnVisibilityUpdateToJSONTyped(value?: ColumnVisibilityUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userList': UserListUpdateToJSON(value['userList']),
        'userGroupDetails': UserGroupDetailsUpdateToJSON(value['userGroupDetails']),
        'userProductivityList': UserProductivityListUpdateToJSON(value['userProductivityList']),
        'vehicleList': VehicleListUpdateToJSON(value['vehicleList']),
        'vehicleProductivityList': VehicleProductivityListUpdateToJSON(value['vehicleProductivityList']),
        'vehicleMovementPeriodList': VehicleMovementPeriodListUpdateToJSON(value['vehicleMovementPeriodList']),
        'maintenanceList': MaintenanceListUpdateToJSON(value['maintenanceList']),
        'fleetAuthenticatePeriodList': FleetAuthenticatePeriodListUpdateToJSON(value['fleetAuthenticatePeriodList']),
        'shockEventList': ShockEventListUpdateToJSON(value['shockEventList']),
        'preOpsAnswerList': PreOpsAnswerListUpdateToJSON(value['preOpsAnswerList']),
        'fleetStatisticsList': FleetStatisticsListUpdateToJSON(value['fleetStatisticsList']),
    };
}

